import {
    GET_SERVICE_REQUEST,
    GET_SERVICE_REQUEST_SUCCESS,
    GET_SERVICE_REQUEST_FAILURE,
    SERVICE_REQUEST_DETAILS,
    SERVICE_REQUEST_DETAILS_SUCCESS,
    SERVICE_REQUEST_DETAILS_FAILURE,
    DOWNLOAD_SERVICE_REQUEST,
    DOWNLOAD_SERVICE_REQUEST_SUCCESS,
    DOWNLOAD_SERVICE_REQUEST_FAILURE

} from "../Constants";

export const GetServiceRequest = (payload) => ({
    type: GET_SERVICE_REQUEST,
    payload
});

export const GetServiceRequestSuccess = (payload) => ({
    type: GET_SERVICE_REQUEST_SUCCESS,
    payload
});

export const GetServiceRequestFailure = (payload) => ({
    type: GET_SERVICE_REQUEST_FAILURE,
    payload
});

export const ServiceRequestDetails = (payload) => ({
    type: SERVICE_REQUEST_DETAILS,
    payload
});

export const ServiceRequestDetailsSuccess = (payload) => ({
    type: SERVICE_REQUEST_DETAILS_SUCCESS,
    payload
});

export const ServiceRequestDetailsFailure = (payload) => ({
    type: SERVICE_REQUEST_DETAILS_FAILURE,
    payload
});

export const DownloadServiceRequest  = (payload) => ({
    type : DOWNLOAD_SERVICE_REQUEST,
    payload
});

export const DownloadServiceRequestSuccess  = (payload) => ({
    type : DOWNLOAD_SERVICE_REQUEST_SUCCESS,
    payload
});

export const DownloadServiceRequestFailure  = (payload) => ({
    type : DOWNLOAD_SERVICE_REQUEST_FAILURE,
    payload
});

